import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/exams')({
  component: RouteComponent,
  loader: () => ({
    crumb: 'Exams',
  }),
});

function RouteComponent() {
  return <Outlet />;
}
